import lodash from 'lodash';
import { ACTIONS } from 'overview/actions/dashboard';

export function setDashboardDataReducer(state, action) {
    if (action && action.type !== ACTIONS.SET_DASHBOARD_DATA) {
        return state;
    }

    const { activeBinders, newBinders, archivedBinders } = action.payload || [];

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            binders : [
                ...activeBinders,
                ...newBinders,
                ...archivedBinders
            ],
        },
    };
}

export function setDashboardBinderStudiesReducer(state, action) {
    if (action && action.type !== ACTIONS.SET_DASHBOARD_BINDER_STUDIES) {
        return state;
    }
    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            binderStudiesSponsors: action.payload.sponsors,
            binderStudiesSiteNumbers: action.payload.siteNumbers,
            binderStudiesBinderTypes: action.payload.binderTypes,
            binderStudiesContacts: action.payload.contacts,
            binderStudiesPrincipalInvestigators: action.payload.principalInvestigators,
            binderStudiesSites: action.payload.sites,
            binderStudiesCros: action.payload.cros,
            binderStudiesDepartments: action.payload.departments,
            binderStudiesDiseaseGroups: action.payload.diseaseGroups,
            bindersStudy_StudyBinders : action.payload.studiesAndBinders,
            binderStudiesCount_StudyBinders : action.payload.totalCount,

        },
    };
}
export function setDashboardBinderStudiesAdminBindersReducer(state, action) {
    if (action && action.type !== ACTIONS.SET_DASHBOARD_BINDER_STUDIES_ADMIN_BINDERS) {
        return state;
    }
    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            binderStudiesSponsorsAdminBinders: action.payload.sponsors,
            binderStudiesSiteNumbersAdminBinders: action.payload.siteNumbers,
            binderStudiesBinderTypesAdminBinders: action.payload.binderTypes,
            binderStudiesContactsAdminBinders: action.payload.contacts,
            binderStudiesPrincipalInvestigatorsAdminBinders: action.payload.principalInvestigators,
            binderStudiesSitesAdminBinders: action.payload.sites,
            binderStudiesCrosAdminBinders: action.payload.cros,
            binderStudiesDepartmentsAdminBinders: action.payload.departments,
            binderStudiesDiseaseGroupsAdminBinders: action.payload.diseaseGroups,
            bindersStudyAdminBinders : action.payload.studiesAndBinders,
            binderStudiesCountAdminBinders : action.payload.totalCount,

        },
    };
}
export function setDashboardBinderStudiesReducerTasks(state, action) {
    if (action && action.type !== ACTIONS.SET_DASHBOARD_BINDER_STUDIES_TASKS) {
        return state;
    }
    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            binderStudiesTasks : action.payload.studiesAndBinders
        },
    };
}

export function setDashboardStudyBinderQueryCount(state, action) {
    if (action && action.type !== ACTIONS.SET_STUDY_BINDER_QUERY_COUNT) {
        return state;
    }
    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            studyBinderQueryCount: action.payload
        },
    };
}

export function setDashboardAdminBinderQueryCount(state, action) {
    if (action && action.type !== ACTIONS.SET_ADMIN_BINDER_QUERY_COUNT) {
        return state;
    }
    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            adminBinderQueryCount : action.payload
        },
    };
}

export function setBinderCustomColumns(state, action) {
    if (action && action.type !== ACTIONS.SET_BINDER_CUSTOM_COLUMNS) {
        return state;
    }
    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            customColumns : action.payload && action.payload.custom_columns || null,
        },
    };
}

export function setUnfiledDocumentsCountToBinderReducer(state, action) {
    if(action && action.type !== ACTIONS.SET_UNFILED_DOCUMENTS_COUNT){
        return state;
    }

    const unfiledDocumentsCount = action.payload;

    const unfiledDocumentsCountKeyById = lodash.keyBy(unfiledDocumentsCount, 'binderId');
    const binders = lodash.get(state, 'dashboard.binders');
    const bindersWithUnfiledDocumentsCount = binders.map( binder => {
        return {
            ...binder,
            unfiledDocumentsCount : unfiledDocumentsCountKeyById[binder.id].unfiledDocsCount
        };
    });

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            binders: bindersWithUnfiledDocumentsCount
        }
    };
}

export function loadingDashboardDataReducer(state, action) {
    if (action && action.type !== ACTIONS.LOADING_DASHBOARD_DATA) {
        return state;
    }

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            loading: true,
        }
    };
}

export function loadedDashboardDataReducer(state, action) {
    if (action && action.type !== ACTIONS.LOADED_DASHBOARD_DATA) {
        return state;
    }

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            loading: false,
        }
    };
}

export function loadingDashboardBinderStudiesReducer(state, action) {
    if (action && action.type !== ACTIONS.LOADING_DASHBOARD_BINDER_STUDIES) {
        return state;
    }

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            loadingBinderStudies: true,
        }
    };
}

export function loadedDashboardBinderStudiesReducer(state, action) {
    if (action && action.type !== ACTIONS.LOADED_DASHBOARD_BINDER_STUDIES) {
        return state;
    }

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            loadingBinderStudies: false,
        }
    };
}

export function loadingDashboardBinderStudiesAdminBindersReducer(state, action) {
    if (action && action.type !== ACTIONS.LOADING_DASHBOARD_BINDER_STUDIES_ADMIN_BINDERS) {
        return state;
    }

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            loadingBinderStudiesAdminBinders: true,
        }
    };
}

export function loadedDashboardBinderStudiesAdminBindersReducer(state, action) {
    if (action && action.type !== ACTIONS.LOADED_DASHBOARD_BINDER_STUDIES_ADMIN_BINDERS) {
        return state;
    }

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            loadingBinderStudiesAdminBinders: false,
        }
    };
}

export function setPinnedBindersReducer(state, action) {
    if (action && action.type !== ACTIONS.SET_PINNED_BINDERS) {
        return state;
    }

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            pinnedBinderIds: action.payload.binderIds,
        }
    };
}

export function loadingUnfiledDocsCount(state, action) {
    if (action && action.type !== ACTIONS.LOADING_UNFILED_DOCS_COUNT) {
        return state;
    }

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            loadingUnfiledDocsCount : action.payload,
        }
    };
} 

export function setPendingTasksToBindersReducer(state, action) {
    if (action && action.type !== ACTIONS.SET_PENDING_TASKS) {
        return state;
    }

    const pendingTasks = action.payload;
    const pendingTasksKeyById = lodash.keyBy(pendingTasks, 'binderId');
    const binders = lodash.get(state, 'dashboard.binders');
    const bindersWithPendingTasksCount = binders.map(binder => {
        return {
            ...binder,
            pendingTasksCount : pendingTasksKeyById[binder.id].taskCount
        };
    });

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            binders : bindersWithPendingTasksCount,
        }
    };
}

export function loadingPendingTasks(state, action) {
    if (action && action.type !== ACTIONS.LOADING_PENDING_TASKS) {
        return state;
    }

    return {
        ...state,
        dashboard: {
            ...state.dashboard,
            loadingPendingTasks : action.payload,
        }
    };
}

export function clearDashboardData(state, action) {
    if (action && action.type !== ACTIONS.CLEAR_DASHBOARD_DATA) {
        return state;
    }

    return {
        ...state,
        dashboard : {
            ...state.dashboard,
            binders : [],
            loadingPendingTasks : false,
            loadingUnfiledDocsCount: false,
            loading: false,
        }
    };
}
